import React from 'react';
import { Box, Container, Typography, Grid, Link, Divider, Fab } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1a237e',
        color: 'white',
        py: 2,
        mt: 'auto',
        position: 'relative'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Localização
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
              <LocationOnIcon sx={{ mr: 1, mt: 0.5 }} />
              <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                R. Luiz Ferreira de Melo<br />
                Centro<br />
                Solânea - PB
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Contato
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <PhoneIcon sx={{ mr: 1 }} />
              <Link 
                href="tel:(83) 3531-3908" 
                color="inherit" 
                underline="hover"
                sx={{ '&:hover': { color: 'secondary.light' } }}
              >
                (83) 3531-3908
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <EmailIcon sx={{ mr: 1 }} />
              <Link 
                href="mailto:contato@ecitapl.com.br" 
                color="inherit" 
                underline="hover"
                sx={{ '&:hover': { color: 'secondary.light' } }}
              >
                contato@ecitapl.com.br
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Horário de Funcionamento
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <AccessTimeIcon sx={{ mr: 1 }} />
              <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                Segunda a Sexta<br />
                7:30h às 17h
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2, borderColor: 'rgba(255, 255, 255, 0.12)' }} />
        
        <Typography 
          variant="body2" 
          align="center" 
          sx={{ 
            opacity: 0.8,
            fontSize: '0.875rem'
          }}
        >
          {new Date().getFullYear()} Rangel Andrade. Todos os direitos reservados.
        </Typography>
      </Container>
      <Fab
        color="primary"
        size="small"
        aria-label="voltar ao início"
        onClick={scrollToTop}
        sx={{
          position: 'absolute',
          right: 16,
          top: -20,
          bgcolor: 'white',
          color: '#1a237e',
          '&:hover': {
            bgcolor: '#e0e0e0'
          }
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Box>
  );
}

export default Footer;
